<template>
    <div class="container-fluid">
        <section class="utility-report-shell">
            <div class="report-hero">
                <div class="report-hero-copy">
                    <p class="hero-eyebrow">Utility Report</p>
                    <h1>Subscription history and utility activity</h1>
                    <p class="hero-text">Review electricity, airtime, data and TV transactions in one clear report with quick actions for meter token application.</p>
                </div>
                <div class="report-stats">
                    <div class="report-stat-card">
                        <span class="stat-label">Total Records</span>
                        <strong>{{ utilityQty || 0 }}</strong>
                        <span class="stat-note">Captured utility transactions</span>
                    </div>
                    <div class="report-stat-card report-stat-card-soft">
                        <span class="stat-label">Report Owner</span>
                        <strong>{{ firstname }} {{ lastname }}</strong>
                        <span class="stat-note">{{ email_address || 'Signed-in user' }}</span>
                    </div>
                </div>
            </div>

            <div class="account-details utility-table-card">
                <div class="col-sm-12 table table-responsive utility-table-inner">
                    <div class="contract-header">
                        <div>
                            All Subscriptions
                            <span class="report-count">{{ utilityQty || 0 }}</span>
                        </div>
                        <div class="table-search-wrap">
                            <input
                                v-model.trim="searchQuery"
                                type="text"
                                class="form-control table-search-input"
                                placeholder="Search subscriptions"
                            >
                            <p class="report-note">Track transaction references, status messages and token actions.</p>
                        </div>
                    </div>

                    <div class="table table-responsive table-sm report-table-wrap">
                        <v-data-table :headers="header" :items="desserts" :search="searchQuery" dense class="utility-data-table table-responsive">
                        <template v-slot:item.reference="{ item }">
                            <div class="a-text"> {{item.reference}}</div>
                        </template>
                        <template v-slot:item.amount="{ item }">
                            <div class="a-text"> {{item.amount}}</div>
                        </template>
                        <template v-slot:item.utility="{ item }">
                            <div class="a-text"> {{item.utility}}</div>
                        </template>
                        
                        <template v-slot:item.transaction="{ item }">
                            <div class="a-text">{{ item.transaction }}</div>
                        </template>
                        <template v-slot:item.response="{ item }">
                            <div class="a-text">{{ item.response }}</div>
                        </template>
                        <template v-slot:item.createdat="{ item }">
                            <div class="a-text">{{ item.createdat }}</div>
                        </template>
                        <template v-slot:item.action="{ item }">
                        <button v-if="item.IsMeter =='electricity'"
                                class="btn btn-success btn-sm d-flex align-items-center gap-1 apply-meter-btn"
                                @click="open_recharge_meter(item.action)">
                                <i class="fas fa-bolt"></i>
                            Apply Token
                        </button>
                        </template>
                        <template v-slot:no-data>
                            <div class="report-empty-state">
                                <i class="fa fa-file-text-o"></i>
                                <h4>No subscriptions yet</h4>
                                <p>Your completed utility transactions will appear here once records are available.</p>
                            </div>
                        </template>
                    </v-data-table>
                </div>
            </div>
            </div>
        </section>

        <div v-if="isRechargeModal">
              <transition name="modal">
                <div class="modal-mask">
                  <div class="modal-container report-modal">
                    <button type="button" class="close-btn" @click="isRechargeModal = false">×</button>

                    <div class="text-center py-3">
                      <h3 class="modal-title mb-3">Recharge Meter</h3>

                      <div class="modal-details text-start mt-3">
                        <p style="font-size: 13px;"><strong>Network:</strong> {{ rechargeDetails.network }}</p>
                        <p style="font-size: 13px;"><strong>Payment Reference:</strong> {{ rechargeDetails.payment_reference }}</p>
                        <p style="font-size: 13px;"><strong>Amount:</strong> ₦{{ rechargeDetails.amount }}</p>
                        <p style="font-size: 13px;"><strong>Purchased Token:</strong> <span v-html="rechargeDetails.purchase_token"></span></p>
                      </div>

                      <p class="text-center mt-3">Do you want to proceed with meter recharge?</p>
                    </div>

                    <div class="text-center mt-4">
                      <button class="btn btn-primary px-4 mr-2" @click="isRechargeModal = false">Cancel</button>
                      <button class="btn btn-success px-4" @click="recharge_meter(rechargeDetails.purchase_token)">
                        Apply Token to Meter
                      </button>
                    </div>

                  </div>
                </div>
              </transition>
        </div>

        <div v-if="isTokenApplied">
            <transition name="modal">
            <div class="modal-mask">
                <div class="modal-container report-modal text-center">
                <h3 class="text-success">Recharge Completed</h3>
                <p>The following token has been applied to your meter:</p>
                <h4 class="fw-bold">{{ tokenUsed }}</h4>
                <p>Power restored successfully ⚡</p>

                <button class="btn btn-primary mt-3"
                        @click="isTokenApplied = false">
                    Done
                </button>
                </div>
            </div>
            </transition>
        </div>
    
        <p>&nbsp;</p>
        <page-loader :is-loading="isLoading"></page-loader>
    </div>
    </template>
      
    <script>
    
    import swal from 'sweetalert2';
    import PageLoader from '../components/PageLoader.vue'
    export default {
    
        name: "UtilityReport",
        components: {
           // quillEditor,
            PageLoader
        },
    
        data() {
            return {
    
                isLoading: false,
                isRightImage: false,
                isLeftImage: false,
                isBackImage: false,
                is_transaction_fee: true,
                is_transaction_fee_hidden: false,
                user_id: '',
                firstname: '',
                lastname: '',
                bank_name: '',
                account_name: '',
                account_number: '',
    
                loading: false,
                loading1: false,
                loading2: false,
                loading3: false,
                role_type: '',
                contract_title: '',
                transaction_type: '',
                delivery_type: '',
                delivery_location: '',
                delivery_time: '',
                contract_amount: '',
                transaction_fee: '',
                whois_paying: '',
                contract_rebate: '',
                product_description: '',
                accept_terms: '',
    
                products: [],
                subcategorys: [],
                selectedFile: '',
                selectedFile1: '',
                selectedFile2: '',
                selectedFile3: '',
                addProduct: false,
                viewProduct: true,
                editorOptions: {
                    placeholder: 'Write something...',
                },
    
                isVariations: false,
                productid: '',
                variations: '',
                vprice: '',
                is_fees_status: false,
                is_submit: false,
                is_submit1: false,
                is_submit2: false,
                is_submit3: false,
                img_url: process.env.VUE_APP_IMAGE_URL,
                header: [
                 
                    {
                        value: 'reference',
                        text: 'Reference'
                    },
                   
                    {
                        value: 'amount',
                        text: '(N)Amount'
                    },
                   
                    {
                        value: 'utility',
                        text: 'Utility'
                    },
                    {
                        value: 'transaction',
                        text: 'Transaction'
                    },
                    {
                        value: 'type',
                        text: 'Type'
                    },
                    {
                        value: 'response',
                        text: 'Description'
                    },
                    {
                        value: 'createdat',
                        text: 'Date'
                    },
                    {
                        value: 'action',
                        text: 'Action'
                    },
                   
                ],
    
                desserts: [],
                searchQuery: '',
                user_role: '',
                product_id: '',
                userid: '',
                utilityQty: '',
                IsMeter: '',
                utilityData: [],
                isPeriod: false,
                delivery_period: '',
                payment_status: '',
                is_escrow_charge: false,
                error: '',
                error1: '',
                duration_twelve: false,
                duration_twelve1: true,
                label1: '',
                isContractLink: false,
                contractLink: '',
                service_charge_fee: '',
                isRechargeModal: false,
                isTokenApplied: false,
                rechargeDetails: {
                network: '',
                purchase_token: '',
                payment_reference: '',
                amount: 0,
                token_reference_number: '',
                recharge_status: ''
            },
            tokenUsed: '',
            };
        },
    
        beforeMount() {
    
        },
    
        mounted() {
    
            this.firstname = localStorage.getItem("firstname");
            this.lastname = localStorage.getItem("lastname");
            this.phone_number = localStorage.getItem("phone");
            this.email_address = localStorage.getItem("email");
            this.user_id = localStorage.getItem("userid");
    
            this.bank_name = localStorage.getItem("bank_name");
            this.account_name = localStorage.getItem("account_name");
            this.account_number = localStorage.getItem("account_number");
            this.user_role = localStorage.getItem("user_role");
    
            this.fetchAllTransactions()
        },
    
        created() {
    
        },
    
        computed: {
    
               
        },
    
        methods: {
            async open_recharge_meter(reference_number){
            try {
                this.token_reference_number = reference_number
                const response = await this.$http.post('/fetch-utility-reference-by-id', {
                reference: reference_number,
                });
                if (!response.data.success) {
                swal.fire({
                    icon: 'error',
                    title: 'Error',
                    width: 450,
                    text: response.data.message,
                });
                return;
                }
                const tokenText = response.data.data.purchase_item;
                //const token = tokenText.match(/\b\d{11,}\b/)[0]; // Finds long numb
                const token = this.extractToken(tokenText); // Finds long numb
                this.rechargeDetails = {
                network: response.data.data.network,
                purchase_token: token,
                payment_reference: response.data.data.payment_reference,
                amount: response.data.data.amount
                };
                this.isRechargeModal = true; // show recharge modal

            } catch (err) {
                console.error(err);
                this.loading = false;
                swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'An unexpected error occurred. Please try again.',
                });
            }
            },

            extractToken(text){
            if (!text) return null;

            // 1️⃣ Remove HTML entities like &nbsp;
            text = text.replace(/&nbsp;/g, ' ');

            // 2️⃣ Match grouped or ungrouped token patterns
            const regex = /(\d[\d\s]{10,}\d)/;

            const match = text.match(regex);
            if (!match) return null;

            // 3️⃣ Clean spaces inside token
            return match[1].replace(/\s+/g, '');
            },

            async recharge_meter(purchase_token){
                try {

                if (this.recharge_status === '1') {
                    swal.fire({
                    icon: 'error',
                    title: 'Error',
                    width: 450,
                    text: 'This token has already been applied to your meter',
                  });
                  return;
                }
                if (this.recharge_status === '2') {
                    swal.fire({
                    icon: 'error',
                    title: 'Error',
                    width: 450,
                    text: 'Meter is out of connection',
                  });
                  return;
                }
                const response = await this.$http.post('/recharge-meter', {
                  purchase_token: purchase_token,
                  reference_number: this.token_reference_number
                });
                if (!response.data.success) {
                  swal.fire({
                    icon: 'error',
                    title: 'Error',
                    width: 450,
                    text: response.data.message,
                  });
                  return;
                }
                const tokenText = purchase_token;
                //const token = tokenText.match(/\b\d{11,}\b/)[0]; // Finds long numb

                if (!tokenText) {
                this.$toast("Token not found!", { type: "error" });
                return;
                }

            this.isRechargeModal = false;

            // Simulate backend API interaction
            setTimeout(() => {
                this.tokenUsed = tokenText;
                this.isTokenApplied = true;
                this.$toast("Token successfully applied to meter!", { type: "success" });
            }, 2000)

            } catch (err) {
                console.error(err);
                this.loading = false;
                swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'An unexpected error occurred. Please try again.',
                });
            }
            },
     
            async fetchAllTransactions() {
                try {
                    this.isLoading = true
                    this.desserts = []
                    const response = await this.$http.get('/fetch-utility-transactions', {
                    })
                    this.isLoading = false
                    
                    this.utilityData = response.data.data
                    this.utilityQty = this.utilityData.length
                    this.utilityData.forEach(el => {
                        this.desserts.push({
                            reference: el.payment_reference,
                            amount: el.amount,
                            profit: el.profit,
                            IsMeter: el.utility,
                            utility: el.utility + ' ' + el.network + ' ' + el.mobile_phone,
                            type: el.transaction_type || 'bank payment',
                            transaction: el.purchase_item || 'N/A',
                            response: el.success_message,
                            createdat: el.created_at,
                            action: el.reference
                            
                        })
                    });
    
                } catch (err) {
                    console.log(err);
                }
            },
               
        }
    
    }
    </script>
      
    <style lang="scss" scoped>
    @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;700&display=swap');
    .container-fluid{
    background:
        radial-gradient(circle at top left, rgba(36, 86, 43, 0.12), transparent 24%),
        linear-gradient(180deg, #f4f8f5 0%, #edf3ee 100%);
    border-radius: 10px;
    min-height: 100vh;
    padding: 1.25rem 1rem 2rem;
    }
    .utility-report-shell{
        max-width: 1240px;
        margin: 0 auto;
    }
    .report-hero{
        display: grid;
        grid-template-columns: 1.35fr 1fr;
        gap: 1.2rem;
        margin-bottom: 1.25rem;
        align-items: stretch;
    }
    .report-hero-copy{
        padding: 2rem;
        border-radius: 28px;
        background: linear-gradient(135deg, #16372d 0%, #24562B 58%, #3d7c50 100%);
        box-shadow: 0 20px 45px rgba(11, 39, 24, 0.1);
        color: #fff;
        font-family: Poppins;
    }
    .hero-eyebrow{
        margin: 0 0 0.65rem;
        font-size: 11px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.12em;
        color: rgba(255,255,255,0.72);
    }
    .report-hero-copy h1{
        margin: 0;
        font-size: 32px;
        line-height: 1.15;
        font-weight: 700;
    }
    .hero-text{
        margin: 0.9rem 0 0;
        max-width: 560px;
        font-size: 14px;
        line-height: 1.75;
        color: rgba(255,255,255,0.84);
    }
    .report-stats{
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 1rem;
        padding: 1rem;
        border-radius: 28px;
        background: rgba(255,255,255,0.72);
        box-shadow: 0 20px 45px rgba(11, 39, 24, 0.07);
        backdrop-filter: blur(10px);
    }
    .report-stat-card{
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        min-height: 176px;
        padding: 1.2rem;
        border-radius: 22px;
        background: linear-gradient(180deg, #ffffff 0%, #f4f8f5 100%);
        border: 1px solid rgba(22, 55, 45, 0.08);
        font-family: Poppins;
    }
    .report-stat-card-soft{
        background: linear-gradient(180deg, #f5fbf6 0%, #eef7f0 100%);
    }
    .stat-label{
        font-size: 11px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.1em;
        color: #6f8579;
    }
    .report-stat-card strong{
        margin: 0.85rem 0 0.55rem;
        font-size: 28px;
        line-height: 1.2;
        color: #16372d;
        word-break: break-word;
    }
    .stat-note{
        font-size: 12px;
        line-height: 1.6;
        color: #66776f;
    }
    .error {
        color: #fff;
      }
      .error1 {
        color: #fff;
      }
    .quill-container {
        height: 200px;
        /* Set the desired height here */
    }
    .copy-refid{
        cursor: pointer;
        font-size: 16px;
    }
    .copy-refid1{
        cursor: pointer;
        font-size: 15px;
        font-weight: 600;
    }
    .a-text {
        font-size: 11px;
        font-family: Poppins;
    }
    .a-text1 {
        font-size: 14px;
        font-family: Poppins;
    }
    .process-payment{
        cursor:pointer;
    
    }
    label {
        font-size: 12px;
        font-family: Poppins;
        font-weight: normal;
    }
    
    .inputs {
        margin-top: 20px;
        border-radius: 3px;
        font-size: 12px;
    }
    
    .price-fee {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    
        div {
            margin: 4px;
            width: 100%;
    
        }
    }
    
    .adjust-fee-input {
        // width: 100px;
        text-align: center;
    }
    
    .whopays-fee-input {
        //width: 100% !important;
    }
    
    .shop-detail {
        font-size: 12px;
        font-family: Poppins;
    }
    
    .btn-danger {
        text-transform: uppercase;
        font-size: 13px;
        font-family: Poppins;
        background: #24562B;
        border: 0px;
        height: 45px;
    }
    
    .contract-header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        gap: 1rem;
        background: linear-gradient(135deg, #16372d 0%, #24562B 100%);
        color: #fff;
        border-radius: 20px;
        padding: 1rem 1.15rem;
        font-size: 14px;
        font-weight: 700;
        font-family: Poppins;
        margin-bottom: 0.9rem;
    }
    .account-details {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 24px;
        background: #fff;
        width: 100%;
    }
    .utility-table-card{
        padding: 1.15rem;
        border: 1px solid rgba(22, 55, 45, 0.07);
        box-shadow: 0 20px 45px rgba(11, 39, 24, 0.07);
    }
    .utility-table-inner{
        margin-bottom: 0;
    }
    .report-count{
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: 32px;
        height: 32px;
        padding: 0 0.7rem;
        margin-left: 0.55rem;
        border-radius: 999px;
        background: rgba(255,255,255,0.16);
        font-size: 12px;
        font-weight: 700;
    }
    .report-note{
        margin: 0;
        font-size: 12px;
        font-weight: 500;
        color: #000;
    }
    .table-search-wrap{
        display: flex;
        flex-direction: column;
        gap: 0.45rem;
        min-width: 260px;
    }
    .table-search-input{
        height: 42px;
        border-radius: 12px;
        border: 0;
        font-family: Poppins;
        font-size: 13px;
    }
    .report-table-wrap{
        margin: 0;
        border: 1px solid #e7efea;
        border-radius: 18px;
        overflow: hidden;
        background: #fff;
    }
    .report-empty-state{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 0.6rem;
        padding: 2.5rem 1.25rem;
        text-align: center;
        font-family: Poppins;
        color: #60746a;
    }
    .report-empty-state i{
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 56px;
        height: 56px;
        border-radius: 50%;
        background: #eef6ef;
        color: #24562B;
        font-size: 22px;
    }
    .report-empty-state h4{
        margin: 0;
        font-size: 18px;
        font-weight: 700;
        color: #16372d;
    }
    .report-empty-state p{
        margin: 0;
        max-width: 420px;
        font-size: 13px;
        line-height: 1.7;
    }
    .apply-meter-btn{
        width: auto;
        min-width: 118px;
        border: 0;
        border-radius: 999px;
        padding: 0.5rem 0.8rem;
        background: #24562B !important;
        box-shadow: 0 10px 22px rgba(36, 86, 43, 0.16);
        font-size: 11px !important;
        font-weight: 700;
        gap: 0.35rem;
    }
    
    .account-balance {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        background: #780712;
        color: #fff;
        width: 100%;
        height: 100%;
        border-radius: 10px;
        font-family: Poppins;
        padding: 0.4rem;
        padding-left: 2rem;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    }
    
    .wallet-detail {
        padding-top: 1rem;
        line-height: 1.4px;
        font-size: 15px;
    
        h4 {
            font-weight: 650;
        }
    
        .acct-d {
            line-height: 0.8;
            cursor: pointer;
            text-decoration: underline;
        }
    }
    
    .wallet-icon {
        font-size: 60px
    }
    
    .fund-account {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        background: #076378;
        color: #fff;
        width: 100%;
        height: 100%;
        border-radius: 10px;
        font-family: Poppins;
        padding: 0.4rem;
        padding-left: 2rem;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    }
    
    .inputs-field {
        font-size: 14px;
        font-family: Poppins;
        height: 45px;
    }
    
    .content-center {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border: solid 1px #170e0fac;
        border-radius: 4px;
        padding: 0.5rem;
        margin: 4px;
    }
    
    .box1 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        font-family: Poppins;
    
        a {
            text-decoration: none;
            color: #000;
        }
    }
    
    .image-input {
        margin-top: 10px;
    }
    
    .box-icon {
        padding-left: 0.4rem;
        font-size: 35px;
        color: #637807;
    }
    
    .box-details {
        font-size: 14px;
        color: #170e0fac;
    }
    
    .box1:hover {
        transform: scale(1.1);
        transition: transform 0.3s ease;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.24);
        cursor: pointer;
    }
    
    .box2 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        font-family: Poppins;
    
        a {
            text-decoration: none;
            color: #000;
        }
    }
    
    .box2:hover {
        transform: scale(1.1);
        transition: transform 0.3s ease;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.24);
        cursor: pointer;
    }
    
    .box3 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        font-family: Poppins;
    
        a {
            text-decoration: none;
            color: #000;
        }
    }
    
    .box3:hover {
        transform: scale(1.1);
        transition: transform 0.3s ease;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.24);
        cursor: pointer;
    }
    
    .box4 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        font-family: Poppins;
    
        a {
            text-decoration: none;
            color: #000;
        }
    }
    
    .box4:hover {
        transform: scale(1.1);
        transition: transform 0.3s ease;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.24);
        cursor: pointer;
    }
    
    .box5 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        font-family: Poppins;
    
        a {
            text-decoration: none;
            color: #000;
        }
    }
    
    .box5:hover {
        transform: scale(1.1);
        transition: transform 0.3s ease;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.24);
        cursor: pointer;
    }
    
    .box6 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        font-family: Poppins;
    
        a {
            text-decoration: none;
            color: #000;
        }
    }
    
    .box6:hover {
        transform: scale(1.1);
        transition: transform 0.3s ease;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.24);
        cursor: pointer;
    }
    
    .img {
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
    }
    
    .box-details {
        padding: 0.4rem;
        line-height: 1.4px;
    
        .title {
            font-family: Poppins;
            font-weight: 550;
            font-size: 10px;
            text-transform: capitalize;
            color: #ff4d63;
        }
    
        .description {
            font-family: Poppins;
            font-size: 12px;
        }
    }
    
    .continue {
        display: flex;
        flex-direction: row;
        justify-content: right;
        padding-right: 0.4rem;
        font-size: 30px;
        color: rgb(237, 138, 108);
        margin-right: 10px;
        margin-top: -10px;
        margin-bottom: 10px;
    }
    
        
.modal-mask {
  position: fixed;
  z-index: 1050;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-container {
  width: 450px;
  background: #fff;
  border-radius: 22px;
  padding: 25px;
  box-shadow: 0 8px 20px rgba(0,0,0,.15);
  animation: fadeIn .3s ease-out;
  position: relative;
}
.report-modal{
  width: min(460px, calc(100vw - 24px));
  padding: 1.6rem;
  box-shadow: 0 22px 45px rgba(0, 0, 0, 0.18);
}

.modal-title {
  color: #24562B;
  text-transform: uppercase;
  font-weight: 700;
  border-bottom: 2px solid #24562B;
  display: inline-block;
  padding-bottom: 5px;
}
.modal-details{
  padding: 1rem;
  border-radius: 16px;
  background: #f7faf8;
  border: 1px solid #e7efea;
}
.modal-details p{
  margin-bottom: 0.75rem;
  color: #284136;
  font-family: Poppins;
}

.icon-success i {
  font-size: 60px;
  color: #28a745;
}

.close-btn {
  background: none;
  border: none;
  font-size: 22px;
  font-weight: bold;
  position: absolute;
  top: 12px;
  right: 12px;
  cursor: pointer;
}

.modal-enter-active, .modal-leave-active {
  transition: opacity .5s;
}

.modal-enter, .modal-leave-to {
  opacity: 0;
}
    :deep(.utility-data-table .v-data-table__wrapper table) {
        min-width: 980px;
    }
    :deep(.utility-data-table thead th) {
        background: #f4f8f5;
        color: #5d7166;
        font-size: 11px;
        font-weight: 700;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        font-family: Poppins;
        border-bottom: 1px solid #e6eeea;
    }
    :deep(.utility-data-table tbody td) {
        padding-top: 14px !important;
        padding-bottom: 14px !important;
        border-bottom: 1px solid #eef3ef;
        background: #fff;
        vertical-align: middle;
    }
    :deep(.utility-data-table tbody tr:hover td) {
        background: #f8fbf8 !important;
    }
    :deep(.utility-data-table .v-data-footer) {
        border-top: 1px solid #eef3ef;
    }
    
    .account-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    
    .account-content-h {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 50px;
    
        padding-top: 1.3rem;
        text-transform: uppercase;
        text-align: center;
        //text-decoration: underline;
    }
    
    .add-fund {
        font-size: 12px;
        text-decoration: none !important;
        text-transform: capitalize;
    }
    
    .account-content-d {
        padding-top: 1.3rem;
        font-size: 14px;
        margin-bottom: 10px;
    }
    
    .btn-secondary {
        text-transform: uppercase;
    }
    
    .modal-close {
        color: #000;
        line-height: 50px;
        font-size: 140%;
        position: absolute;
        right: 0;
        text-align: center;
        top: 2;
        width: 70px;
        text-decoration: none;
    
        &:hover {
            color: black;
        }
    }
    
    .modal-close-mobile {
        color: #000;
        line-height: 50px;
        font-size: 140%;
        position: absolute;
        right: 0;
        text-align: center;
        top: 2;
        width: 70px;
        text-decoration: none;
    
        &:hover {
            color: black;
        }
    
        display: none;
    }
    
    a {
        text-decoration: none;
    }
    
    .shop-name {
        //font-weight: 550;
        color: #000;
        font-family: Poppins;
    }
    
    @media screen and (max-width: 768px) {
        .container-fluid{
        padding: 0 0px 0 0rem;
    }
        .copy-refid1{
            cursor: pointer;
            font-size: 14px;
            font-weight: 600;
        }
        .inputs-field {
            font-size: 12px;
            font-family: Poppins;
            font-weight: normal;
            height: 45px;
        }
        .contract-header {
    
            font-size: 12px !important;
    
        }
    
        .counter {
            font-size: 13px;
            font-weight: 500 !important;
        }
    
        .welcome {
            font-family: Poppins;
            font-size: 16px;
            font-weight: 700;
            text-align: left;
            color: #170e0fac;
        }
    
        .content-center {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 0.9rem;
        }
    
        .image-input {
            margin-top: 20px;
        }
    
        .price-fee {
            display: flex;
            flex-direction: column;
    
            div {
                width: 100%;
            }
        }
        .margin-mobile{
            margin-top: 90px;;
        }
    
        .adjust-fee-input {
            width: 100%;
        }
    
        .account-details {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            border-radius: 4px;
            width: 100%;
        }
    
        .account-balance {
            margin-bottom: 10px;
        }
    
        .box-details {
            padding: 0.4rem;
            line-height: 1.4px;
    
            .title {
                font-family: Poppins;
                font-weight: 550;
                font-size: 8px;
                text-transform: capitalize;
                color: #ff4d63;
            }
    
            .description {
                font-family: Poppins;
                font-size: 12px;
            }
        }
    
        .inputs {
            font-size: 12px;
        }
    
        .box1 {
            width: 100%;
            height: 100%;
            border-radius: 10px;
            margin-bottom: 10px;
        }
    
        .box2 {
            width: 100%;
            height: 100%;
            border-radius: 10px;
            margin-bottom: 10px;
        }
    
        .box3 {
            width: 100%;
            height: 100%;
            border-radius: 10px;
            margin-bottom: 10px;
        }
    
        .box4 {
            width: 100%;
            height: 100%;
            border-radius: 10px;
            margin-bottom: 10px;
        }
    
        .box5 {
            width: 100%;
            height: 100%;
            border-radius: 10px;
            margin-bottom: 10px;
        }
    
        .continue {
            display: flex;
            flex-direction: row;
            justify-content: right;
            padding-right: 0.4rem;
            font-size: 30px;
            margin-top: -10px;
            color: rgb(237, 138, 108);
        }
    
        .modal-close-mobile {
            display: block;
        }
    
        .modal-close {
            display: none;
        }
    
        .account-content {
            margin: 0px;
            margin-right: 0px;
        }
    
    }

    @media screen and (max-width: 991px) {
        .container-fluid{
            padding: 1rem 0.85rem 1.5rem;
        }
        .report-hero{
            grid-template-columns: 1fr;
        }
        .report-hero-copy{
            padding: 1.45rem;
        }
        .report-hero-copy h1{
            font-size: 26px;
        }
        .report-stats{
            grid-template-columns: 1fr;
        }
        .report-stat-card{
            min-height: auto;
        }
        .contract-header{
            flex-direction: column;
            align-items: flex-start;
        }
        .utility-table-card{
            padding: 0.9rem;
        }
    }

    @media screen and (max-width: 767px) {
        .contract-header{
            border-radius: 16px;
            padding: 0.9rem 1rem;
        }
        .report-count{
            margin-left: 0.35rem;
        }
        .report-note{
            line-height: 1.5;
        }
        .report-table-wrap{
            border-radius: 14px;
        }
        .report-modal{
            padding: 1.15rem;
        }
    }
    </style>
    
